import { useCallback, useEffect, useState } from 'react';

// Measures an element's rendered height and publishes it as a CSS var on the document root
export const useTrackElementHeightVar = (cssVar: string) => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  const ref = useCallback((node: HTMLElement | null) => {
    setElement(node);
  }, []);

  useEffect(() => {
    if (!element) {
      return;
    }

    const applyHeight = (height: number) => {
      document.documentElement.style.setProperty(cssVar, `${height}px`);
    };

    applyHeight(element.getBoundingClientRect().height);

    const observer = new ResizeObserver((entries) => {
      const [entry] = entries;
      if (entry) {
        applyHeight(entry.contentRect.height);
      }
    });
    observer.observe(element);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty(cssVar);
    };
  }, [element, cssVar]);

  return ref;
};
